<div class="portal-content">
    <h1>CyberRangeᶜᶻ Platform Portal</h1>
    @if (hasNoAgendas()) {
        <p class="portal-empty">
            Your account has no agenda assigned. Ask an administrator to grant you a role.
        </p>
    } @else {
        <div class="portal-menu">
            @for (portalAgendaContainer of portalAgendaContainers(); track portalAgendaContainer) {
                <crczp-portal-agenda-container
                    [portalAgendaContainer]="portalAgendaContainer"
                    [elevation]="elevated"
                    (navigation)="navigateToRoute($event)"
                    (setElevation)="setElevation($event)"/>
            }
        </div>
    }
</div>
